
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield, ShieldAlert, AlertTriangle, ShieldCheck, ShieldQuestion } from "lucide-react";
import { getSeverityColor } from "@/utils/securityUtils";
import { useNavigate } from "react-router-dom";

interface SecurityEventSummary {
  event_type: string;
  severity: string;
  count: number;
  unresolved_count: number;
}

interface SecuritySummaryCardProps {
  item: SecurityEventSummary;
}

export const getSeverityIcon = (severity: string) => {
  switch (severity.toLowerCase()) {
    case 'critical':
      return <ShieldAlert className="h-5 w-5" />;
    case 'high':
      return <AlertTriangle className="h-5 w-5" />;
    case 'medium':
      return <Shield className="h-5 w-5" />;
    case 'low':
      return <ShieldCheck className="h-5 w-5" />;
    default:
      return <ShieldQuestion className="h-5 w-5" />;
  }
};

export const SecuritySummaryCard = ({ item }: SecuritySummaryCardProps) => {
  const navigate = useNavigate();

  return (
    <Card 
      className="cursor-pointer hover:shadow-md transition-shadow"
      onClick={() => navigate(`/admin/security/events/${item.severity.toLowerCase()}`)}
    >
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          {getSeverityIcon(item.severity)}
          <span className={getSeverityColor(item.severity)}>
            {item.severity}
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{item.count || 0}</div>
        <p className="text-xs text-muted-foreground">
          {item.unresolved_count || 0} unresolved
        </p>
      </CardContent>
    </Card>
  );
};
